import type { Shadows } from '@mui/material/styles/shadows';

import type { ColorScheme } from './types';

export const shadows = {
  dark: [
    'none',
    '0 1px 2px rgba(0, 0, 0, 0.28)',
    '0 2px 4px rgba(0, 0, 0, 0.3)',
    '0 4px 8px rgba(0, 0, 0, 0.32)',
    '0 6px 12px rgba(0, 0, 0, 0.34)',
    '0 8px 16px rgba(0, 0, 0, 0.36)',
    '0 10px 18px rgba(0, 0, 0, 0.38)',
    '0 12px 20px rgba(0, 0, 0, 0.4)',
    '0 14px 22px rgba(0, 0, 0, 0.42)',
    '0 16px 24px rgba(0, 0, 0, 0.44)',
    '0 18px 26px rgba(0, 0, 0, 0.46)',
    '0 20px 28px rgba(0, 0, 0, 0.48)',
    '0 22px 30px rgba(0, 0, 0, 0.5)',
    '0 24px 32px rgba(0, 0, 0, 0.52)',
    '0 26px 34px rgba(0, 0, 0, 0.54)',
    '0 28px 36px rgba(0, 0, 0, 0.56)',
    '0 30px 38px rgba(0, 0, 0, 0.58)',
    '0 32px 40px rgba(0, 0, 0, 0.6)',
    '0 34px 42px rgba(0, 0, 0, 0.62)',
    '0 36px 44px rgba(0, 0, 0, 0.64)',
    '0 38px 46px rgba(0, 0, 0, 0.66)',
    '0 40px 48px rgba(0, 0, 0, 0.68)',
    '0 42px 50px rgba(0, 0, 0, 0.7)',
    '0 44px 52px rgba(0, 0, 0, 0.72)',
    '0 46px 54px rgba(0, 0, 0, 0.74)',
  ],
  light: [
    'none',
    '0 1px 2px rgba(15, 23, 42, 0.06)',
    '0 2px 4px rgba(15, 23, 42, 0.07)',
    '0 4px 8px rgba(15, 23, 42, 0.08)',
    '0 6px 10px rgba(15, 23, 42, 0.08)',
    '0 8px 12px rgba(15, 23, 42, 0.09)',
    '0 10px 14px rgba(15, 23, 42, 0.09)',
    '0 12px 16px rgba(15, 23, 42, 0.1)',
    '0 14px 18px rgba(15, 23, 42, 0.1)',
    '0 16px 20px rgba(15, 23, 42, 0.11)',
    '0 18px 22px rgba(15, 23, 42, 0.11)',
    '0 20px 24px rgba(15, 23, 42, 0.12)',
    '0 22px 26px rgba(15, 23, 42, 0.12)',
    '0 24px 28px rgba(15, 23, 42, 0.13)',
    '0 26px 30px rgba(15, 23, 42, 0.13)',
    '0 28px 32px rgba(15, 23, 42, 0.14)',
    '0 30px 34px rgba(15, 23, 42, 0.14)',
    '0 32px 36px rgba(15, 23, 42, 0.15)',
    '0 34px 38px rgba(15, 23, 42, 0.15)',
    '0 36px 40px rgba(15, 23, 42, 0.16)',
    '0 38px 42px rgba(15, 23, 42, 0.16)',
    '0 40px 44px rgba(15, 23, 42, 0.17)',
    '0 42px 46px rgba(15, 23, 42, 0.17)',
    '0 44px 48px rgba(15, 23, 42, 0.18)',
    '0 46px 50px rgba(15, 23, 42, 0.18)',
  ],
} satisfies Record<ColorScheme, Shadows>;
